import { useState } from "react";
import { Anchor, ChevronRight } from "lucide-react";

export const Login = ({ onLogin }) => {
  const [role, setRole] = useState("Petugas TPI");
  const [error, setError] = useState("");
  const submit = (e) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    if (data.get("email") && data.get("password")) onLogin(role);
    else setError("Email dan kata sandi wajib diisi.");
  };
  return <main className="login-page"><div className="login-photo" /><section className="login-panel">
    <div className="brand-mark"><Anchor size={22} /><span>SIP-IKAN</span></div>
    <div className="login-copy"><p className="eyebrow">TPI SANTOLO · PAMEUNGPEUK</p><h1>Data laut, keputusan<br /><em>lebih tepat.</em></h1><p>Kelola hasil tangkapan, kapal, lelang, dan harga ikan dalam satu ruang kerja yang sederhana.</p></div>
    <form onSubmit={submit} data-testid="login-form">
      <label>Email petugas<input name="email" type="email" placeholder="nama@tpi-pameungpeuk.id" data-testid="login-email-input" /></label>
      <label>Kata sandi<input name="password" type="password" placeholder="Masukkan kata sandi" data-testid="login-password-input" /></label>
      <div className="role-picker"><span>Masuk sebagai</span><div>{["Petugas TPI", "Admin"].map((item) => <button type="button" className={role === item ? "selected" : ""} onClick={() => setRole(item)} key={item} data-testid={`login-role-${item.toLowerCase().replace(" ", "-")}`}>{item}</button>)}</div></div>
      {error && <p className="form-error" data-testid="login-error">{error}</p>}
      <button className="primary wide" type="submit" data-testid="login-submit-button">Masuk ke SIP-IKAN <ChevronRight size={18} /></button>
    </form>
    <p className="login-foot">Versi awal · Data tersimpan aman di perangkat ini · <a href="/php/" data-testid="open-php-version-link">Buka versi PHP + MySQL</a></p>
  </section></main>;
};
